import type { IUserAddress } from "../../../types";
import { EAddressStatus } from "../../../constants/address.constants";

export const getAddressStatus = (address: IUserAddress): string => {
  if (address.status?.toLowerCase() === EAddressStatus.UNVERIFIED)
    return EAddressStatus.UNVERIFIED;
  if (address.defaultAddress) return EAddressStatus.DEFAULT;
  return EAddressStatus.OTHER;
};
